'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('dynamic-page', {
      url: '/page/:name',
      template: '<dynamic-page></dynamic-page>',
        authenticate: true
    })
    .state('dynamic-page-param', {
      url: '/page/:name/:param',
      template: '<dynamic-page></dynamic-page>',
        authenticate: true
    })
    .state('public-dynamic-page', {
      url: '/public/page/:name',
      template: '<dynamic-page public="true"></dynamic-page>'
  });
}



// WEBPACK FOOTER //
// ./client/~ap/app/dynamic-pages/view/dynamic-page.routes.js